<style>
</style>
<template>
  <div class="container">
    <div>
      <div class="row">
        <div class="form-group col-md-12">
          <div class="card-header" v-if="status_dec=0">
            <h4 class="title">No anexaste el acuse de la declaración fiscal, agregalo aquí:</h4>
          </div>
          <div class="card card-wizard" id="wizardCard">
            <div class="col-md-12" v-if="obligado=='SI'">
              <div class="alert alert-warning">
                <span>De acuerdo a la información capturada, usted está obligado a cargar su acuse de declaración fiscal</span>
              </div>
            </div>
            <div class="row m-3">
              <legend>Cargar acuse de la declaración fiscal</legend>
            </div>

            <div class="col-md-12 form-group">
              <div v-if="add_item">
                <div class="row m-3">
                  <div class="col-md-12 form-group" style="text-align: left">
                    Seleccione archivo en formato PDF
                  </div>
                  <div class="col-md-6 custom-file">
                    <input id="xlsx" ref="xlsx" accept=".pdf" @change="addFile('xlsx')" v-validate="'required'" name="file" type="file" class="custom-file-input">
                    <label class="custom-file-label" for="xlsx">Archivo seleccionado: {{ xlsx ? xlsx.name : '' }}</label>
                    <br><small class="text-danger">{{ errors.first('file')}}</small>
                  </div>
                  <!-- <div class="col-md-2">
                    <button v-if="xlsx!=0" ref="btnSave" class="btn btn-primary">
                      <i class="fa fa-send"></i> Guardar</button>
                  </div> -->
                </div>
                <!--  <div class="row">
                    <a class="btn btn-primary" target="_blank" :href="this.el_archivo">Declaración fiscal.pdf</a>
                    <button ref="" v-on:click="cambiar_archivo" class="btn btn-primary ml-3">
                      <i class="fa fa-send"></i> Cambiar</button>
                  </div> -->
                <div class="row justify-content-end m-3">
                  <button class="btn btn-primary" @click.prevent="addItem()">
                    <span v-if="!edit_item ">
                      <i class="fa fa-plus"></i> Agregar </span>
                    <span v-else>
                      <i class="fa fa-save"></i> Guardar </span>
                  </button>
                  <button class="btn btn-danger ml-3" @click.prevent="cancelEdit()">
                    <span>
                      <i class="fa fa-times"></i> Cancelar </span>
                  </button>
                </div>

                <div class="row ">
                  <hr class=" bg-info">
                </div>
              </div>
              <div>
                <div class="row justify-content-end ml-3 mr-3">
                  <button class="btn btn-primary" @click.prevent="showItem()" v-if="!add_item && fileExist">
                    <span>
                      <i class="fa fa-plus"></i> Agregar </span>
                  </button>
                </div>
                <div class="row mt-3 mb-4">
                  <div class="col-sm-12 col-md-12 col-lg-12">
                    <v-text-field class="col-4 offset-8" v-model="search" append-icon="fa-search" placeholder="Buscar" single-line hide-details>
                    </v-text-field>
                    <v-data-table :headers="headers" :items="table_list" :items-per-page="5" :search="search" class="" :fixed-header="true">
                      <template v-slot:item.acciones="{ item }">
                        <div class="d-flex justify-content-center">
                          <!-- <b-button :href="'https:'+$rootUrl+'/declaraciones_fiscales/'+item.file" class="btn-s edit mr-2" variant="primary" target="_blank" style="line-height: 25px;">

                            <i class="far fa-file-pdf"></i>
                          </b-button> -->
                          <b-button class="btn-s edit mr-2" variant="primary" @click.prevent="descargaFiscal(item.file)">
                            <i class="far fa-file-pdf"></i>
                          </b-button>
                          <br>
                          <!-- <b-button @click.prevent="editItem(item)" class="btn-s edit mr-2" variant="success">
                            <i class="fas fa-pencil-alt"></i></b-button>
                             :class="(hideButtons(item.created_at) != currentYear)?'btn-secondary':'btn-danger'"
                          <br> -->
                          <!-- <b-button @click.prevent="removeItem(item)" class="btn-s delete" variant="danger" :disabled="hideButtons(item.created_at) != currentYear" :class="(hideButtons(item.created_at) != currentYear)?'btn-secondary':'btn-danger'">
                            <i class="fas fa-times"></i></b-button> -->
                        </div>
                      </template>
                      <template v-slot:item.anio="{ item }">
                        <div>{{filterAnio(item.created_at)}}</div>
                      </template>
                      <template v-slot:item.file="{ item }">
                        <div>Declaración fiscal {{filterAnio(item.created_at)}}</div>
                      </template>
                      <template v-slot:item.fecha="{ item }">
                        <div>{{dateFormat3(item.created_at)}}</div>
                      </template>
                    </v-data-table>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" style="margin: 12px;">
              <div class="col-12 text-right" v-if="status_dec=1">
                <button class="btn btn-info btn-fill btn-wd btn-next" @click="siguente()">Siguiente</button>
              </div>
              <div class="col-12 text-right" v-if="status_dec=0">
                <button class="btn btn-info btn-fill btn-wd btn-next">Enviar</button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
  import {
    FormWizard,
    TabContent
  } from "vue-form-wizard";
  import "vue-form-wizard/dist/vue-form-wizard.min.css";
  import moment from 'moment';
  import swal from "sweetalert2";
  export default {
    data() {
      return {
        rol: null,
        ip_id: null,
        el_archivo: "",
        wizardModel: {},
        fiscal: [],
        obligado: '',
        xlsx: 0,
        currentYear: '',
        add_item: false,
        edit_item: false,
        search: '',
        form_item: {},
        table_list: [],
        headers: [{
          text: 'Año',
          value: 'anio',
          align: 'center',
          class: '',
          width: "200px",
        }, {
          text: 'Documentos',
          align: 'center',
          sortable: false,
          value: 'acciones',
          width: "200px",

        }, {
          text: 'Declaración fiscal',
          value: 'file',
          align: 'center',
          class: ''
        }, {
          text: 'Fecha presentación',
          value: 'fecha',
          align: 'center',
          class: '',
          width: "200px",
        }],
      };
    },
    components: {
      FormWizard
    },
    computed: {
      fileExist() {
        let obj = this.table_list.find(o => moment(o.created_at, 'YYYY-MM-DD').format('YYYY') === this.currentYear);
        if (obj) {
          return false;
        } else {
          return true;
        }
      }
    },
    watch: {
      '$route': 'checkPermissions'
    },
    methods: {
      descargaFiscal(file) {
        const token = this.$jwt.getToken();
        const auth = 'Bearer ' + (token ? token.hash : "");

        // var url = [this.$http.options.root + 'declaraciones_fiscales/' + file];
        var url = ['https:' + this.$rootUrl + '/declaraciones_fiscales/' + file];

        window.open(url, '_blank');
      },
      hideButtons(date) {
        return moment(date, 'YYYY-MM-DD').format('YYYY');
      },
      dateFormat3: function (date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss');
      },
      showItem() {
        this.add_item = true;
        this.$validator.resume();
      },
      cancelEdit() {
        this.add_item = false;
        this.edit_item = false;
        this.form_item = {};
        this.$validator.pause();
      },
      addItem() {
        this.$validator.validateAll().then(response => {
          if (response) {
            const formData = new FormData();
            formData.append("upload_file", this.xlsx);
            this.Ask("Esta apunto de subir el Acuse de la presentación de su declaración fiscal, si NO es el archivo correcto, después de subirlo deberá solicitar permiso para cualquier tipo de cambio ¿desea continuar?", () => {
              this.$http.post("fiscal", formData).then(
                response => {
                  this.StepOk("Guardado");
                  if (!this.edit_item) {
                    this.table_list.unshift({
                      ...response.data.response
                    });
                  } else {
                    let index = this.table_list.map(u => {
                      return u.id;
                    }).indexOf(response.data.response.id);
                    this.table_list.splice(index, 1, response.data.response);
                  }
                  this.cancelEdit();

                },
                error => {
                  this.Err(error);
                }
              );
            });
          }
        });
      },
      removeItem(item) {
        if (item.id !== null) {
          this.Ask("Desea borrar este registro", () => {
            this.$http.delete("fiscal/" + item.id).then(response => {
              let index = this.table_list.map(u => {
                return u.id;
              }).indexOf(item.id);
              this.table_list.splice(index, 1);
              this.StepOk('Registro eliminado');
            }, error => {
              this.Err(error);
            });
          });
        }
      },
      checkPermissions() {
        //&& this.getKey('status_dec') == 1
        // && this.getKey('grupo') != 3
        if (!(this.getKey('role') == 0)) {
          localStorage.clear();
          this.$router.push('/login');
          this.$router.go();
        }
      },

      addFile(tipo) {
        this.xlsx = this.$refs.xlsx.files[0];
      },
      siguente() {
        this.$router.push("observaciones");
      },
      /* validateFirstStep() {
        return this.$refs.firstStep.validate();
      },
      validateSecondStep() {
        return this.$refs.secondStep.validate();
      }, */

      /* wizardComplete() {
        // we gather models from all steps into one model
        this.wizardModel = {
          ...this.$refs.datosPersonales.model,
          ...this.$refs.firstStep.model,
          ...this.$refs.DatosCurriculares.model,
          ...this.$refs.DatosConyuge.model,
          ...this.$refs.secondStep.model
        };
        swal("Good job!", "You clicked the finish button!", "success");
      } */
    },
    created() {
      this.currentYear = moment().format('YYYY');

      this.checkPermissions()
      this.ip_id = this.getId();

      this.status_dec = this.getKey('status_dec');

      // this.rol = this.getKey("grupo");

      this.$http.get("fiscal/" + this.ip_id).then(
        response => {
          //console.log(response.data.dec.file);
          this.table_list = response.data.files;
          /* console.log(response.data.files.file);
                    this.el_archivo = response.data.files.file;
                    if (this.el_archivo.length > 1) {
                      this.el_archivo =
                        "https:"+$rootUrl+"/declaraciones_fiscales/" +
                        response.data.files.file;
                    } */
        },
        error => {
          this.Err(error);
        }
      );
      //  console.log('a');

      this.$http.get("oblfiscal/" + this.ip_id).then(
        response => {
          this.obligado = response.data.obligado
        },
        error => {
          this.Err(error);
        }
      );
    }
  };

</script>
<style>
  .vue-form-wizard .wizard-icon-circle.tab_shape {
    background-color: #9a9a9a !important;
    color: white;
  }


  .custom-file-label::after {
    content: "Buscar" !important;

  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Fiscal.vue